<template>
  <div class="payout-list">
    <v-data-table
        :headers="headers"
        :items="adminPendingPurchases"
        sort-by="id"
        :loading="tableLoader"
        loading-text="Fetching Pending Payments..."
        no-data-text="There are no pending payments."
        class="mb-12 elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Pending Payments</v-toolbar-title>
        </v-toolbar>
      </template>

      <template v-slot:item.executionTimestamp="{ item }">
        {{ item.executionTimestamp | timestampToDate }}
      </template>

      <template v-slot:item.user.emailAddress="{ item }">
        <router-link :to="`/user/${item.id}`">
          {{ item.user.emailAddress }}
        </router-link>
      </template>

      <template v-slot:item.amountOwed="{ item }">
        {{ item.amountOwed | numberToMoney }}
      </template>

      <template v-slot:item.actions="{ item }">
        <!-- Record Payment Modal -->
        <v-dialog
            v-model="recordPaymentDialog"
            max-width="600px"
        >
          <PendingPaymentPaidConfirm
              v-on:dialogClose="recordPaymentDialog = false"
          ></PendingPaymentPaidConfirm>
        </v-dialog>

        <v-icon
            @click="recordPayment(item)"
        >
          mdi-cash-check
        </v-icon>
      </template>

    </v-data-table>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'
import PendingPaymentPaidConfirm from './PendingPaymentPaidConfirm.vue'

export default {

  name: 'PendingPaymentList',

  components: {
    PendingPaymentPaidConfirm
  },

  computed: {
    ...mapGetters([
      'adminPendingPurchases'
    ])
  },

  data: () => ({
    tableLoader: true,
    recordPaymentDialog: false,

    search: '',

    // Mapping datatable.
    headers: [
      {
        text: 'Requested',
        value: 'executionTimestamp',
        align: 'start'
      },
      {
        text: 'Asset',
        value: 'asset.name',
        sortable: true
      },
      {
        text: 'Email',
        value: 'user.emailAddress',
        sortable: true
      },
      {
        text: 'Amount Owed',
        value: 'amountOwed',
        align: 'right'
      },
      {
        text: 'Resolve',
        value: 'actions',
        align: 'end',
        sortable: false
      }
    ]
  }),

  methods: {
    ...mapActions([
      'getPendingPurchases'
    ]),

    ...mapMutations([
      'setPendingPurchaseRequest'
    ]),

    recordPayment: function (payoutRequest) {
      this.setPendingPurchaseRequest(payoutRequest)
      this.recordPaymentDialog = true
    }
  },

  created() {
    this.getPendingPurchases().then(() => {
      this.tableLoader = false
    })
  }
}
</script>
